import React from 'react';
import {
  AppBar,
  Avatar,
  Box,
  Container,
  CssBaseline,
  Grid,
  IconButton,
  Toolbar,
  Typography,
  Button,
  Paper,
  Divider,
  TextField,
} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ShieldIcon from '@mui/icons-material/Security';
import { useParams } from 'react-router-dom';
import jobsApi from '@diditusa/shared/api/jobsApi';
import LoadingIndicator from '@diditusa/shared/web_components/LoadingIndicator/loadingIndicator';
import { format } from 'date-fns';
const JobDetailsPage: React.FC = () => {
  const { jobId } = useParams();
  const { data: jobDetails, ...getJobDetailsState } = jobsApi.useGetJobQuery(parseInt(jobId!));

  const renderAgentDetails = () => {
    if (!jobDetails || !jobDetails.jobAssignments) {
      return (
        <Paper
          elevation={0}
          sx={{ display: 'flex', alignItems: 'center', p: 2, mb: 2, bgcolor: '#f8fafc' }}
        >
          <Avatar
            src='https://lh3.googleusercontent.com/aida-public/AB6AXuAwZwT...'
            sx={{ width: 56, height: 56 }}
          />
          <Box ml={2}>
            <Typography variant='subtitle1' fontWeight={500}>
              Assigned Agent:
            </Typography>
            <Typography variant='body2' color='#4e7a97'>
              Agent Bio
            </Typography>
          </Box>
        </Paper>
      );
    }
    return jobDetails?.jobAssignments.map((ja) => (
      <>
        <Paper
          elevation={0}
          sx={{ display: 'flex', alignItems: 'center', p: 2, mb: 2, bgcolor: '#f8fafc' }}
        >
          <Avatar src={ja.user?.imageUrl} sx={{ width: 56, height: 56 }} />
          <Box ml={2}>
            <Typography variant='subtitle1' fontWeight={500}>
              Assigned Agent: <strong>{`${ja.user?.firstName} ${ja.user?.lastName}`}</strong>
            </Typography>
            <Typography variant='body2' color='#4e7a97'>
              Agent Bio
            </Typography>
          </Box>
        </Paper>

        <Typography variant='body1' px={2} pb={3}>
          {ja.user?.bio || `${ja.user?.firstName}'s bio is under construction`}
        </Typography>
      </>
    ));
  };

  const renderCompanyDetails = () => {
    return (
      <Paper
        elevation={0}
        sx={{ display: 'flex', alignItems: 'center', p: 2, mb: 2, bgcolor: '#f8fafc' }}
      >
        <Avatar sx={{ bgcolor: '#e7eef3', width: 48, height: 48 }}>
          <ShieldIcon />
        </Avatar>
        <Box ml={2}>
          <Typography variant='subtitle1' fontWeight={500}>
            Service Provider: <strong>{jobDetails?.company?.name}</strong>
          </Typography>
          <Typography variant='body2' color='#4e7a97'>
            {jobDetails?.company?.licenses?.join(',') || 'PILB#'}
          </Typography>
        </Box>
      </Paper>
    );
  };

  const renderJobDetails = () => {
    if (!jobDetails) {
      return <p>Not found</p>;
    }
    return (
      <>
        <Typography variant='h6' fontWeight='bold' px={2} py={2}>
          Job Information
        </Typography>

        <Grid container spacing={2} px={2}>
          {[
            ['Service', jobDetails.securityOption?.title],
            ['Date', jobDetails.startTime.toFormat('MM/dd/yyyy')],
            ['Time', jobDetails.startTime.toFormat('hh:mm a ZZZZ')],
            ['Location', jobDetails.location],
            ['Additional Details', jobDetails.description],
          ].map(([label, value]) => (
            <React.Fragment key={label}>
              <Grid size={{ xs: 12, sm: 3 }} textAlign='start'>
                <Typography variant='body2' color='#4e7a97'>
                  {label}
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, sm: 9 }}>
                <Typography variant='body2'>{value}</Typography>
                <Divider sx={{ my: 2, borderColor: '#d0dee7' }} />
              </Grid>
            </React.Fragment>
          ))}
          <Grid size={12}>
            <Typography variant='body2' fontWeight='bold' px={2} py={2}>
              Admin Notes
            </Typography>
            <TextField
              value={jobDetails.adminNotes}
              slotProps={{
                input: {
                  readOnly: true,
                },
              }}
              placeholder={'No notes from admin.'}
              multiline
              rows={8}
              maxRows={8}
              fullWidth
            />
          </Grid>
        </Grid>
      </>
    );
  };
  const getContent = () => {
    if (getJobDetailsState.isLoading) {
      return <LoadingIndicator isVisible={getJobDetailsState.isLoading} />;
    }
    return (
      <>
        <Typography variant='h6' fontWeight='bold' px={2} py={2}>
          Assigned Security Detail
        </Typography>

        {renderCompanyDetails()}
        {renderAgentDetails()}
        {renderJobDetails()}
      </>
    );
  };
  return (
    <Box
      sx={{
        fontFamily: 'Inter, Noto Sans, sans-serif',
        bgcolor: '#f8fafc',
        minHeight: '100vh',
        textAlign: 'start',
      }}
    >
      <Container maxWidth='lg' sx={{ py: 5 }}>
        <Box>
          <Box px={2} pb={2}>
            <Typography variant='h4' fontWeight='bold' gutterBottom>
              Job Details
            </Typography>
            <Typography variant='body2' color='#4e7a97'>
              View the details of your assigned security detail.
            </Typography>
          </Box>

          {getContent()}
        </Box>
      </Container>
    </Box>
  );
};

export default JobDetailsPage;
